/**
 * Join class names, dropping anything falsy.
 *
 * Small enough not to be worth a dependency, and it keeps conditional classes
 * readable: `cx(styles.btn, isDanger && styles.danger)`.
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
